import React, { useEffect, useState } from "react";
import { Badge, Button, Space } from "antd";
import { MasterConfigs } from "../../interfaces/entity";
import ViewHeading from "../ViewHeading/ViewHeading";
import { useSelector } from "react-redux";

interface Props {
    config: MasterConfigs,
    setAction: (text) => void,
    filterVisible?: boolean,
    access?: { create?: boolean; view?: boolean; edit?: boolean }
}

const ControlesComponent: React.FC<Props> = ({
    config,
    setAction,
    filterVisible,
    access
}) => {
    const query: any = useSelector((app: any) => app?.app?.query)
    const [filterValue, setFilter] = useState(false)

    useEffect(() => {
        if (query && query?.fields && Object.keys(query?.fields).length) {
            setFilter(true)
        } else if (query && query?.conditions && Object.keys(query?.conditions).length) {
            setFilter(true)
        } else {
            setFilter(false)
        }
    }, [query])

    const getControls = () => {
        const { actions } = config;
        const _actions = actions?.map(ele => {
            if (!ele) return null;

            // Hide Add button if user doesn't have create access
            // Only show Add button if access exists and create is explicitly true
            if (ele.actionType === 'Add' && (!access || !access.create)) {
                return null;
            }

            // If it's a Custom action with render function, use the render function
            if (ele.actionType === 'Custom' && ele.render) {
                return ele.render();
            }

            // Otherwise, render as a Button
            return <Button onClick={() => ele.onClick ? ele.onClick() : setAction(ele.actionType)} {...ele.settings}>
                <Badge dot={filterValue && ele.actionType == "filter"}>
                    {ele.name}
                </Badge>
            </Button >
        }).filter(Boolean) // Remove null values
        const array = config?.extraControles ? config?.extraControles : []
        return _actions ? [..._actions, ...array] : array;
    }

    return <>
        <Space direction="vertical" style={{ width: '100%' }}>
            {React.cloneElement(<ViewHeading filterVisible={filterVisible} controls={getControls()} isSmall={true} config={config}>
                {config.title}
            </ViewHeading>)
            }
        </Space>
    </>
}

export default ControlesComponent;

